/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationDetailRequest extends models.PromptRecommendationDetailRequestBase {
    getFixupPrototypeFunction() { return PromptRecommendationDetailRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationDetailRequest>): PromptRecommendationDetailRequest {
        let obj = Object.assign(new PromptRecommendationDetailRequest(), model);
        PromptRecommendationDetailRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationDetailRequest>): PromptRecommendationDetailRequest {
        if (!model) return null;
        return PromptRecommendationDetailRequest.newInstance(<PromptRecommendationDetailRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationDetailRequest) {
        if (!obj) return;

        models.PromptRecommendationDetailRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationDetailRequest): boolean {
        if (models.PromptRecommendationDetailRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PromptRecommendationDetailRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Start date for metrics
     */
    start_date: Date;

    /**
     * End date for metrics
     */
    end_date: Date;

    /**
     * Currently deployed model to drill into
     */
    model_id: string;

    /**
     * Service account scope
     */
    service_account_id: string;

}
